var ProgramViewController = (function () {
    function ProgramViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.table = { sortType: '_link', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.programs = [];
        this.programsLoaded = false;
        this.table.headers = [{
                'Profile ID': '_link', 'Program': 'program', 'IOT': 'imt', 'Countries': 'countries',
                'Brands': 'brands', 'BP Types': 'bp_types'
            }];
        this.socket.forward('config.program_summary', this.$scope);
        this.$scope.$on('socket:config.program_summary', function (event, data) {
            _this.programs = data;
            _this.programsLoaded = true;
        });
    }
    ProgramViewController.prototype.prepLink = function (value, link) {
        var split = value.split('|');
        if (link) {
            return split[0];
        }
        else {
            return split[1]; //Name
        }
    };
    ProgramViewController.prototype.$onInit = function () {
        this.admin.getSummaryProgramProfiles();
    };
    ProgramViewController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    ProgramViewController.prototype.createNew = function () {
        this.$state.go('admin.program', 'new');
    };
    ProgramViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return ProgramViewController;
}());
var ProgramViewComponent = (function () {
    function ProgramViewComponent() {
        this.templateUrl = 'program-view.html';
        this.controllerAs = 'vm';
        this.controller = ProgramViewController;
    }
    return ProgramViewComponent;
}());
angular
    .module('application')
    .component('viewProgramSection', new ProgramViewComponent());

//# sourceMappingURL=program.view.component.js.map
